import React from 'react'
import styled from 'styled-components'
import ShareIcon from '../../../images/share.svg'
import { trackEvent } from '../../analytics/client'
import { ANALYTICS_EVENTS } from '../../analytics/events'

const Image = styled.img`
    width: 32px;
`

/**
 * Copies the given text to clipboard.
 * @param {String} text text to copy
 */
const copyText = (text) => {
    const textarea = document.createElement('textarea')
    textarea.setAttribute('type', 'hidden')
    textarea.textContent = text
    document.body.appendChild(textarea)
    textarea.select()
    document.execCommand('copy')
    document.body.removeChild(textarea)
}

const ShareButton = ({ onClick, ...props }) => {
    const onClickShare = async () => {
        trackEvent(ANALYTICS_EVENTS.SHARE_INITIATED, {
            source: 'share_button',
        })
        if (onClick) {
            onClick()
            return
        }
        if (navigator.share) {
            try {
                await navigator.share({
                title: 'Join this Crossword with me!',
                text: 'Join this Crossword with me!',
                url: window.location.href,
                })
                trackEvent(ANALYTICS_EVENTS.SHARE_COMPLETED, {
                    source: 'share_button',
                })
            } catch (err) {
                console.error(err)
            }
        } else {
            copyText(window.location.href)
            window.alert('The URL has been copied to your clipboard!')
            trackEvent(ANALYTICS_EVENTS.SHARE_COMPLETED, {
                source: 'share_button',
                method: 'clipboard',
            })
        }
    }

    return (
        <Image src={ShareIcon} onClick={onClickShare} {...props} />
    )
}

export default ShareButton
